
import React, { useEffect, useRef, useState } from "react";
import CreateCustomeUi from "./CreateCustomeUi";
import Layout from "../../Components/Layout/Layout";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import moment from "moment";

// Define validation schema using Yup
const validationSchema = Yup.object({
  name: Yup.string()
    .required("Please enter a name")
    .min(2, "Name must be at least 2 characters long"),
  select: Yup.string().required("Please select an option"),
  date: Yup.string().required("Please select a date"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Please enter an email address"),
  password: Yup.string()
    .min(5, "Your password must be at least 5 characters long")
    .required("Please provide a password"),
  terms: Yup.boolean()
    .oneOf([true], "Please accept our terms")
    .required("You must accept the terms of service"),
});

function CreateCustom() {
  const [date, setDate] = useState("");
  const [dateRange,setDateRange]=useState("");
  const datepickerRef = useRef(null);
const daterangepickerRef = useRef(null)
  useEffect(() => {
    $(datepickerRef.current)
      .datepicker({
        format: "mm/dd/yyyy",
        todayBtn: "linked",
        autoclose: true,
        startDate: new Date(), // Disable past dates
      })
      .on("changeDate", function (e) {
        setDate(e.format("mm/dd/yyyy"));
      });

    return () => {
      $(datepickerRef.current).datepicker("destroy");
    };
  }, []);
  useEffect(() => {
    // Initialize the Date Range Picker
    $('#reservation').daterangepicker({
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
      // Additional options can be added here
    }, function(start, end) {
      // Update formik state with the selected date range
      // formik.setFieldValue('dateRange', `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`);
    });
  }, []);
  return (
    <Layout>
      <Formik
        initialValues={{
          name: "",
          select: "",
          date: "",
          email: "",
          password: "",
          terms: false,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          alert("Form successfully submitted!");
        }}
      >
        {(formik) => (
          <CreateCustomeUi
            formik={formik}
            date={date}
            dateRange={dateRange}
            datepickerRef={datepickerRef}
            daterangepickerRef={daterangepickerRef}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default CreateCustom;
